import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { INVOICE_LIST } from './type';

export const getInvoiceList = (
  page = 1,
  limit = 15,
  filterData = null
) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    filterData === null
      ? `${Config.brandActivation.invoiceList}/?limit=${limit}&page=${page}`
      : `${Config.brandActivation.invoiceList}/?limit=${limit}&page=${page}${
          filterData.status ? `&status=${filterData.status}` : ''
        }${filterData?.date ? `&date=${filterData.date}` : ''}`
  );
  if (res) {
    dispatch({ type: INVOICE_LIST, payload: res.data });
    return res;
  }
};

export const addPayment = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.addPayment
  );
  if (res?.status === 200) {
    return true;
  } else return false;
};
